import React from 'react';

export const TableRowInput = ({ title, type, name, value, onChange }) => (
    <tr>
        <th>{title}</th>
        <td>
            <input type={type} className="input-no-border form-control" name={name} value={value} onChange={onChange} />
        </td>
    </tr>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tr-input.jsx